import closest from '@mailobj-browser/front/js/selectors/closest.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'

export default (select, template, input) => {
  const { ownerDocument } = select
  const { value } = input
  const { textContent } = closest('label', input)
  const option = ownerDocument.createElement('option')
  
  replaceChildren(select, template, Object.assign(option, {
    textContent,
    value
  }))
}
